import { shallowEqual, useSelector } from 'react-redux';

export interface FeedbackSliceState {
    feedback: Record<string, unknown>;
    isLoading: boolean;
}

export interface FeedbackFormSliceState {
    isLoading: boolean;
    teacherDescription: string | null;
    teacherName: string | null;
    audioUrl: string | null;
    email: string | null;
    autoSubmit: boolean;
    reportResult: unknown;
}

interface FeedbackRootState {
    feedback: FeedbackSliceState;
    feedbackForm: FeedbackFormSliceState;
}

const selectFeedback = (state: FeedbackRootState) => state.feedback;
const selectFeedbackForm = (state: FeedbackRootState) => state.feedbackForm;

export const useFeedback = (): FeedbackSliceState =>
    useSelector(selectFeedback, shallowEqual);

export const useFeedbackForm = (): FeedbackFormSliceState =>
    useSelector(selectFeedbackForm, shallowEqual);
